
 
export const FETCH_DISCOUNT_GROUPS_REQUEST = 'discountGroups/FETCH_DISCOUNT_GROUPS_REQUEST';
export const FETCH_DISCOUNT_GROUPS_SUCCESS = 'discountGroups/FETCH_DISCOUNT_GROUPS_SUCCESS';
export const FETCH_DISCOUNT_GROUPS_FAILURE = 'discountGroups/FETCH_DISCOUNT_GROUPS_FAILURE';

 
export const FETCH_DISCOUNT_GROUP_REQUEST = 'discountGroups/FETCH_DISCOUNT_GROUP_REQUEST';
export const FETCH_DISCOUNT_GROUP_SUCCESS = 'discountGroups/FETCH_DISCOUNT_GROUP_SUCCESS';
export const FETCH_DISCOUNT_GROUP_FAILURE = 'discountGroups/FETCH_DISCOUNT_GROUP_FAILURE';

 
export const DELETE_DISCOUNT_GROUP_REQUEST = 'discountGroups/DELETE_DISCOUNT_GROUP_REQUEST';
export const DELETE_DISCOUNT_GROUP_SUCCESS = 'discountGroups/DELETE_DISCOUNT_GROUP_SUCCESS';
export const DELETE_DISCOUNT_GROUP_FAILURE = 'discountGroups/DELETE_DISCOUNT_GROUP_FAILURE';

 
export const CREATE_DISCOUNT_GROUP_REQUEST = 'discountGroups/CREATE_DISCOUNT_GROUP_REQUEST';
export const CREATE_DISCOUNT_GROUP_SUCCESS = 'discountGroups/CREATE_DISCOUNT_GROUP_SUCCESS';
export const CREATE_DISCOUNT_GROUP_FAILURE = 'discountGroups/CREATE_DISCOUNT_GROUP_FAILURE';

 
export const UPDATE_DISCOUNT_GROUP_REQUEST = 'discountGroups/UPDATE_DISCOUNT_GROUP_REQUEST';
export const UPDATE_DISCOUNT_GROUP_SUCCESS = 'discountGroups/UPDATE_DISCOUNT_GROUP_SUCCESS';
export const UPDATE_DISCOUNT_GROUP_FAILURE = 'discountGroups/UPDATE_DISCOUNT_GROUP_FAILURE';


export const UPDATE_FIELD = 'discountGroups/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'discountGroups/SET_DEFAULT_DATA';
